module.exports = __webpack_public_path__ + "static/media/performance_48.02645bdb.png";